import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchasePayment, PurchasePaymentCreate, PurchasePaymentFilter } from '../data/purchasePayment';

export function createPurchasePaymentService(client: AxiosInstance) {
  return createCrudService<PurchasePayment, PurchasePaymentCreate, PurchasePaymentFilter>(
    client,
    '/purchase/PurchasePayment',
    'id',
  );
}

export type PurchasePaymentService = CrudService<PurchasePayment, PurchasePaymentCreate, PurchasePaymentFilter>;
